module.exports = __webpack_public_path__ + "img/NIS_People.eb6b82d4.svg";